// import "babel-polyfill";
import Vue from 'vue';
import App from './App.vue';
import router_main from './router';
import router_sub from './subrouter';
import GullKit from './plugins/gull.kit';
import store from './store';
import Breadcumb from './components/breadcumb';
import i18n from './lang/lang';
import Vuelidate from 'vuelidate';
import fabric from 'fabric';
import VModal from 'vue-js-modal';
import VueFlashMessage from 'vue-flash-message';
//import AudioRecorder from 'vue-audio-recorder'
import VTooltip from 'v-tooltip';
import axios from 'axios';
import VueRecord from '@codekraft-studio/vue-record';
import feather from 'vue-icon';

import infiniteScroll from 'vue-infinite-scroll';

import VueSocketio from 'vue-socket.io';
import SocketIO from 'socket.io-client';

import '~/plugins';
import '~/components';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import GAuth from 'vue-google-oauth2';

// use fontawesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(fas);
library.add(fab);
library.add(far);

Vue.component('fa-icon', FontAwesomeIcon);

import upgradePlan from './components/upgradePlan';
import autoComplete from './components/autoComplete';

const gauthOption = {
  clientId: '362176621571-gop42ce4706rm7ltj7457ngcetriqfv0.apps.googleusercontent.com',
  scope: 'https://www.googleapis.com/auth/youtube.upload',
  prompt: 'consent',
  access_type: 'offline'
};
Vue.use(GAuth, gauthOption);

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

Vue.use(VTooltip);
Vue.use(GullKit);
Vue.use(VModal, { dialog: true });
Vue.use(infiniteScroll);
// Vue.use(AudioRecorder)
Vue.use(fabric);
Vue.use(Vuelidate);
Vue.use(VueFlashMessage);
Vue.use(VueRecord);
Vue.use(feather, 'v-icon');

if (process.env.MIX_S3_STORAGE == 1 || process.env.MIX_S3_STORAGE == '1') {
  Vue.use(
    new VueSocketio({
      connection: SocketIO(process.env.MIX_APP_URL + ':' + process.env.MIX_SOCKET_PORT)
    })
  );
} else {
  // Vue.use(
  //   new VueSocketio({
  //     connection: SocketIO("http://localhost:3010"),
  //   })
  // );
}

Vue.component('breadcumb', Breadcumb);
Vue.component('upgradePlan', upgradePlan);
Vue.component('autoComplete', autoComplete);

Vue.use(Loading, {
  loader: 'dots',
  color: '#FFFF73',
  backgroundColor: '#3e3838'
});

VTooltip.options.defaultTemplate =
  '<div class="tooltip-vue" role="tooltip"><div class="tooltip-vue-arrow"></div><div class="tooltip-vue-inner"></div></div>';
VTooltip.options.defaultArrowSelector = '.tooltip-vue-arrow, .tooltip-vue__arrow';
VTooltip.options.defaultInnerSelector = '.tooltip-vue-inner, .tooltip-vue__inner';

const router = () => {
  if ('https://' + window.location.hostname == process.env.MIX_RESELLER_URL) {
    return router_sub;
  }
  return router_main;
};

new Vue({
  store,
  router: router(),
  i18n,
  render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js